<div class="aicoach-container" *ngIf="task && task.details.aicoach && task.details.aicoach.length > 0">
  <div *ngFor="let item of task.details.aicoach; let i = index" class="aicoach-item swiper-no-swiping" (click)="goToAICoach(i)">
    <img [src]="item.picture_url | safeUrl" credentialless>
  </div>
</div>
